import { gql } from "@apollo/client";

// ─── Queries ─────────────────────────────────────────────────────────────────

export const CHAT_INTEGRATION = gql`
  query ChatIntegration($organizationId: ID!) {
    chatIntegration(organizationId: $organizationId) {
      _id
      organizationId
      provider
      status
      channelId
      channelName
      workspaceName
      installedAt
      installedBy
      disconnectedAt
      challengeAnnouncementsEnabled
      leaderboardDropsEnabled
      rewardShoutoutsEnabled
      eventAnnouncementsEnabled
      lastBroadcastAt
      lastBroadcastType
      totalBroadcasts
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const AVAILABLE_BROADCAST_CHANNELS = gql`
  query AvailableBroadcastChannels($organizationId: ID!) {
    availableBroadcastChannels(organizationId: $organizationId) {
      id
      name
      memberCount
      isPrivate
    }
  }
`;

// ─── Mutations ───────────────────────────────────────────────────────────────

export const INITIATE_CHAT_INTEGRATION = gql`
  mutation InitiateChatIntegration(
    $organizationId: ID!
    $provider: ChatProviderType!
  ) {
    initiateChatIntegration(
      organizationId: $organizationId
      provider: $provider
    )
  }
`;

export const SELECT_BROADCAST_CHANNEL = gql`
  mutation SelectBroadcastChannel(
    $organizationId: ID!
    $input: SelectBroadcastChannelInput!
  ) {
    selectBroadcastChannel(organizationId: $organizationId, input: $input) {
      _id
      channelId
      channelName
      status
    }
  }
`;

export const UPDATE_BROADCAST_SETTINGS = gql`
  mutation UpdateBroadcastSettings(
    $organizationId: ID!
    $input: UpdateBroadcastSettingsInput!
  ) {
    updateBroadcastSettings(organizationId: $organizationId, input: $input) {
      _id
      challengeAnnouncementsEnabled
      leaderboardDropsEnabled
      rewardShoutoutsEnabled
      eventAnnouncementsEnabled
    }
  }
`;

export const DISCONNECT_CHAT_INTEGRATION = gql`
  mutation DisconnectChatIntegration($organizationId: ID!) {
    disconnectChatIntegration(organizationId: $organizationId)
  }
`;

export const REFRESH_CHAT_INTEGRATION_STATUS = gql`
  mutation RefreshChatIntegrationStatus($organizationId: ID!) {
    refreshChatIntegrationStatus(organizationId: $organizationId) {
      _id
      status
      workspaceName
      channelId
      channelName
    }
  }
`;

export const TEST_BROADCAST = gql`
  mutation TestBroadcast($organizationId: ID!) {
    testBroadcast(organizationId: $organizationId)
  }
`;
